import {Component,OnInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
@Component({
  standalone: false,
  selector: 'alg-process-detail',
  templateUrl: './process-detail.html',
})
export class ProcessDetailComponent implements OnInit {
  processId: string;

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.processId = this.route.snapshot.paramMap.get('processId');
  }


}
